<template>
  <div>
    <app-nav-bar></app-nav-bar>
    <leaflet-map></leaflet-map>
  </div>
</template>

<script>
import navbar from '../components/Navbar.vue'
import leafletMap from '../components/Map.vue'
export default {
  components: {
    appNavBar: navbar,
    leafletMap
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/view/Accueil.vue